import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

const BASE = "/revision-access-requests";

export interface RevisionAccessRequest {
  id: number;
  register_no: string;
  pasien_rm: string;
  document_type?: string | null;
  document_id?: number | null;
  document_label?: string | null;
  document_type_label?: string | null;
  requester_id: number;
  requester_unit_id: string | null;
  reason: string;
  approver_id: number | null;
  approver_note: string | null;
  rejection_reason: string | null;
  status: "pending" | "approved" | "rejected" | "expired" | "revoked";
  granted_minutes: number | null;
  approved_at: string | null;
  rejected_at: string | null;
  expires_at: string | null;
  register_dout_snapshot: string | null;
  register_hout_snapshot: string | null;
  register_discharge_at_snapshot?: string | null;
  created_at: string;
  updated_at: string;
  requester?: { id: number; email: string };
  approver?: { id: number; email: string } | null;
  unit?: { KODE: string; nama: string } | null;


  requester_nama?: string | null;
  approver_nama?: string | null;
  pasien_nama?: string | null;
  pasien_rm_display?: string | null;
  discharge_at?: string | null;
}

export interface ActiveCheckResponse {
  has_active: boolean;
  has_pending: boolean;
  active: {
    id: number;
    approved_at: string;
    expires_at: string;
    granted_minutes: number;
    approver_id: number;
    approver_note: string | null;
  } | null;
  pending: {
    id: number;
    created_at: string;
    reason: string;
  } | null;
  document?: {
    is_finalized: boolean;
    unfinalized_at: string | null;
    revision_request_id: number | null;
  } | null;
}

export interface RevisionScope {
  register_no: string;
  document_type?: string;
  document_id?: number;
}

export type SubmitRevisionPayload = RevisionScope & { reason: string };

async function submitRequest(payload: SubmitRevisionPayload) {
  const res = await http.postData(BASE, payload).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return res.data.data as RevisionAccessRequest;
}

async function fetchActive(scope: RevisionScope) {
  // PENTING: pakai getDataParam (bukan getData) supaya query params terkirim.
  const res = await http
    .getDataParam(`${BASE}/active`, { params: scope })
    .catch(err => {
      // Diam-diam — sering dipanggil dari banner saat tidak relevan.
      return Promise.reject(err);
    });
  return res.data as ActiveCheckResponse;
}

async function fetchMy(params?: { status?: string; register_no?: string }) {
  const res = await http
    .getDataParam(`${BASE}/my`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return res.data.data as RevisionAccessRequest[];
}

async function fetchAll(params?: { status?: string }) {
  const res = await http.getDataParam(BASE, { params }).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return res.data.data as RevisionAccessRequest[];
}

async function approve(
  id: number,
  payload: { granted_minutes?: number; note?: string }
) {
  const res = await http
    .postData(`${BASE}/${id}/approve`, payload)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return res.data.data as RevisionAccessRequest;
}

async function reject(id: number, payload: { rejection_reason: string }) {
  const res = await http
    .postData(`${BASE}/${id}/reject`, payload)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return res.data.data as RevisionAccessRequest;
}

export default {
  submitRequest,
  fetchActive,
  fetchMy,
  fetchAll,
  approve,
  reject
};
